import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import UserEdit from './views/User/Edit'
import AuthCallback from '@/views/AuthCallback'

import PageNotFound from '@/components/error/PageNotFound'
import GenericError from '@/components/error/GenericError'
import Forbidden from '@/components/error/Forbidden'
import keycloak from "@/plugins/keycloak";
import Keycloak from "keycloak-js";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/edit-account',
      name: 'userEdit',
      component: UserEdit
    },
    {
      name: 'pageNotFound',
      path: '*',
      component: PageNotFound
    },
    {
      name: 'genericError',
      path: '*',
      component: GenericError
    },
    {
      name: 'forbiddenError',
      path: '*',
      component: Forbidden
    }
  ]
})

const notAuthRoutes = ['logout', 'authCallback', 'pageNotFound', 'genericError', 'forbiddenError', 'start']

router.beforeEach((to, from, next) => {
  if (notAuthRoutes.includes(to.path) || notAuthRoutes.includes(to.name)) {
    next()
    return
  }
  if (
    !Vue.usailSecurity.getUser() ||
    !Vue.keycloak.authenticated ||
    Vue.keycloak.tokenParsed.sub !== Vue.usailSecurity.getUser().sub
  ) {
    Vue.keycloak.login({
      redirectUri: window.origin + '/auth-callback'
    })
  }

  next()
})

export function isNoAuthRoute() {
  return notAuthRoutes.includes(router.currentRoute.path) || notAuthRoutes.includes(router.currentRoute.name)
}

export default router
